import { createStyles } from '@material-ui/core/styles';

import fonts from '../fonts';
import { colors } from '../colors';

export default createStyles({
  root: {
    '&.MuiAvatar-root': {
      width: 32,
      height: 32,
    },
    '&.MuiAvatar-colorDefault': {
      color: colors.fontGray,
      background: colors.white,
      fontSize: fonts.sizes.large,
      lineHeight: '14px',
      letterSpacing: '0.15px',
    },
  },
});
